import { Copy, MessageCircle } from "lucide-react";
import { toast } from "sonner";

export const ReferralShareActions = ({ code, compact = false }) => {
  const link = `${window.location.origin}/?ref=${encodeURIComponent(code)}`;
  const message = `I love the tiramisu from Tiramisu & Co! Use my code ${code} to get 10% off your first order: ${link}`;

  const copy = async () => {
    await navigator.clipboard?.writeText(link);
    toast.success("Referral link copied.");
  };

  return (
    <div className={`flex flex-wrap gap-2 ${compact ? "" : "mt-4"}`}>
      <button
        type="button"
        onClick={copy}
        data-testid="referral-copy-link-button"
        className="inline-flex items-center gap-2 border border-espresso px-4 py-2 text-[10px] uppercase tracking-[0.16em] text-espresso transition-colors hover:bg-espresso hover:text-ivory"
      >
        <Copy size={13} strokeWidth={1.6} /> Copy link
      </button>
      <a
        href={`https://wa.me/?text=${encodeURIComponent(message)}`}
        target="_blank"
        rel="noreferrer"
        data-testid="referral-whatsapp-share-button"
        className="inline-flex items-center gap-2 bg-espresso px-4 py-2 text-[10px] uppercase tracking-[0.16em] text-ivory transition-colors hover:bg-gold-hover"
      >
        <MessageCircle size={13} strokeWidth={1.6} /> WhatsApp
      </a>
    </div>
  );
};